import React from 'react'
import { IconArrowNext } from '../../assets/icons'
import { List } from 'react-native-paper'
import { useResponsive } from '../../utils/hooks'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

export const ListItem = ({
  style,
  onPress,
  icon = () => <IconArrowNext />,
  title,
  titleStyle,
  isLast,
  index,
  total,
  ...props
}) => {
  const { mobileWidth } = useResponsive()

  return (
    <List.Item
      titleStyle={composeStyle(
        {
          fontWeight: '600',
          color: 'black',
          opacity: 0.5,
        },
        titleStyle,
      )}
      style={composeStyle(
        {
          borderColor: '#E5E5E5',
          borderTopWidth: 1,
          width: mobileWidth,
          paddingVertical: 10,
          paddingHorizontal: 15,
        },
        isLast || index === total - 1 ? { borderBottomWidth: 1 } : {},
        style,
      )}
      title={title}
      titleNumberOfLines={2}
      onPress={onPress}
      right={icon}
      {...props}
    />
  )
}
